<script lang="ts" setup>
defineProps<{ text: string; title?: string; btnText?: string; icon?: string }>();
defineEmits(['btn-click']);
</script>

<template>
  <div class="flex justify-center items-center gap-3 pb-2">
    <div class="grid gap-1">
      <div
        v-if="title"
        class="font-bold text-lg"
      >
        {{ title }}
      </div>

      <div>{{ text }}</div>
    </div>

    <TheBtn
      v-if="btnText"
      size="md"
      @click="$emit('btn-click')"
    >
      {{ btnText }}
    </TheBtn>
  </div>
</template>
